import { ReactNode } from 'react'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../../../ui/accordion'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../../../ui/tooltip'
import { InfoIcon } from 'lucide-react'
import { AccordionHeader } from '@radix-ui/react-accordion'

type Props = {
  title?: string
  children?: ReactNode
  disabled?: boolean
  collapsible?: boolean
  tooltip?: ReactNode
  isPressable?: boolean
}

const Section = (props: Props) => {
  // If section is empty return nothing so title will not show
  if (!props.children) return <div></div>

  return (
    <Accordion
      type="single"
      disabled={props.disabled}
      defaultValue={!props.collapsible ? 'item-1' : 'item'}
      className="px-5"
    >
      <AccordionItem value="item-1">
        {props.isPressable === undefined && !props.isPressable ? (
          <AccordionHeader className={`text-secondary`}>
            {props.tooltip === undefined ? (
              <p>{props.title}</p>
            ) : (
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger
                    className={`flex items-center gap-2 hover:text-accent-foreground transition ease-in-out duration-300`}
                  >
                    <p>{props.title}</p>
                    <InfoIcon size={18} />
                  </TooltipTrigger>
                  <TooltipContent>{props.tooltip}</TooltipContent>
                </Tooltip>
              </TooltipProvider>
            )}
          </AccordionHeader>
        ) : (
          <AccordionTrigger>
            <p>{props.title}</p>
          </AccordionTrigger>
        )}
        <AccordionContent className="mb-8">
          <div className="grid grid-cols-2 gap-6 px-2 mt-3">
            {props.children}
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  )
}

export default Section
